module.exports = __webpack_public_path__ + "static/media/logo bartatex.2217a05c.png";